import { TimepointSubmissionStatus } from '@common/config/api/client'
import { createContext } from 'react'

export type ExamReassignementContextType = {
  sourceStatus: TimepointSubmissionStatus | null
  destinationStatus: TimepointSubmissionStatus | null
  setSourceStatus: (status: TimepointSubmissionStatus | null) => void
  setDestinationStatus: (status: TimepointSubmissionStatus | null) => void
}

export const ExamReassignementContext = createContext<ExamReassignementContextType | undefined>(undefined)
